
export function hasLoaded(els, callback) {

	if (els.length === 0) return callback()
		
	let loaded = 0
	function checkAll() {
		if (loaded === els.length) callback()
	}
	
	function setLoaded() {
		loaded++
		checkAll()
	}

	function checkImg(el) {
		if (el.complete) { 
			setLoaded()
		} else {
			el.addEventListener('load', () => {
				setLoaded()
			}, { once: true })
		}
	}

	function checkVideo(el) {
		if (el.readyState > 2) {
			setLoaded()
		} else {
			function handler(event) {
				if (event.currentTarget.readyState > 2)	{
					el.removeEventListener('readystatechange', handler)
					setLoaded()
				}
			}
			el.addEventListener('readystatechange', handler)
		}
	}

	els.map(el => {
		if (el.nodeName === 'IMG') checkImg(el)
		if (el.nodeName === 'VIDEO') checkVideo(el)
	})
}